export default __webpack_public_path__ + "img/76d0a709114580c0399324b33dfc6846.svg";